import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';

let app: FirebaseApp | undefined;
let authInstance: Auth | undefined;
let dbInstance: Firestore | undefined;

function ensureFirebase(): void {
  if (app) return;

  const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
  if (!apiKey) {
    throw new Error(
      'Firebase is not configured. Add REACT_APP_FIREBASE_* variables to your .env file.'
    );
  }

  app = initializeApp({
    apiKey,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  });

  authInstance = getAuth(app);
  dbInstance = getFirestore(app);
}

export function getFirebaseAuth(): Auth {
  ensureFirebase();
  return authInstance!;
}

export function getFirebaseDb(): Firestore {
  ensureFirebase();
  return dbInstance!;
}

export default function getFirebaseApp(): FirebaseApp {
  ensureFirebase();
  return app!;
}
